var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m81.716 200 30 30c15.621 15.621 40.947 15.621 56.568 0l30-30H230c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20H50c-11.046 0-20-8.954-20-20v-20c0-11.046 8.954-20 20-20zM150 20c5.523 0 10 4.477 10 10v130l32.929-32.929c3.905-3.905 10.237-3.905 14.142 0l10.858 10.858c3.905 3.905 3.905 10.237 0 14.142l-63.787 63.787c-7.81 7.81-20.474 7.81-28.284 0l-63.787-63.787c-3.905-3.905-3.905-10.237 0-14.142l10.858-10.858c3.905-3.905 10.237-3.905 14.142 0L120 160V30c0-5.523 4.477-10 10-10z"
})));
export default SvgDownload;